import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';

import React from 'react';
import colors from '@/config/colors';

const data = [
  {
    id: 1,
    boldTitle: 'kurz',
    content: [
      { title: 'Anzahl', body: '10-12 Sätze' },
      {
        title: 'Nebensätze',
        body: 'einfache Nebensätze (Relativsätze, Objektsätze, Adverbialsätze mit „weil“, „nachdem“, „als“, „damit“)',
      },
      {
        title: 'Tempus',
        body: 'Präsens, Präteritum, Perfekt, Plusquamperfekt',
      },
      { title: 'Modus', body: 'kein Konjunktiv, nur Indikativ' },
      { title: 'Genus verbi', body: 'Aktiv, kein Passiv' },
    ],
  },
  {
    id: 2,
    boldTitle: 'lang',
    content: [
      { title: 'Anzahl', body: '17-20 Sätze' },
      {
        title: 'Nebensätze',
        body: 'Subjekt- und Objektsätze, Relativsätze, Adverbialsätze, Appositionen',
      },
      {
        title: 'Tempus',
        body: 'Präsens, Präteritum, Perfekt, Plusquamperfekt, Futur 1/2',
      },
      { title: 'Modus', body: 'Indikativ und Konjunktiv' },
      { title: 'Genus verbi', body: 'Aktiv und Passiv' },
    ],
  },
  {
    id: 3,
    boldTitle:
      'Die schwierigen Texte unterscheiden sich von den einfachen Texten in der Komplexität des Themas und des Wortschatzes.',
    content: [],
  },
];

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 10,
  },
  text: {
    fontSize: 18,
    fontWeight: '500',
    color: colors.darkGrey,
    marginVertical: 15,
  },
  bold: {
    fontSize: 18,
    color: colors.darkGrey,
    fontWeight: '700',
  },
  tableRow: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  width20: {
    flex: 0.2,
  },
  width80: {
    flex: 0.8,
  },
  borderTop: {
    width: '100%',
    height: 1,
    backgroundColor: '#3a3a3a',
  },
});

export function ContentText() {
  return (
    <View style={styles.container}>
      {data.map((eachData) => {
        const { id, boldTitle, content } = eachData;
        return (
          <React.Fragment key={id}>
            <View style={styles.borderTop} />
            <View>
              <Text style={[styles.text, styles.bold]}>{boldTitle}</Text>
              {content.map((eachContent) => {
                const { body, title } = eachContent;
                return (
                  <View style={styles.tableRow} key={title}>
                    <Text style={[styles.text, styles.width20]}>{title}</Text>
                    <Text style={[styles.text, styles.width80]}>{body}</Text>
                  </View>
                );
              })}
            </View>
          </React.Fragment>
        );
      })}
    </View>
  );
}
